'use client'

import { useTranslation } from '@/hooks/client/use-translation'
import type { FilterOptions } from '@/lib/directory/build-filter-options'
import type { FacetCounts } from '@/lib/directory/facet-counts'

import { FilterGroups } from './filter-groups'

import { ActionType, countActiveFilters, type DirectoryAction, type DirectoryFilters } from '../use-directory-reducer'

interface FilterRailProps {
  filters: DirectoryFilters
  filterOptions: FilterOptions
  counts: FacetCounts
  dispatch: React.Dispatch<DirectoryAction>
}

// Desktop: the facets stay in view beside the list, sticky under the site nav
// and scrolling within their own column when they run long.
export const FilterRail = ({ filters, filterOptions, counts, dispatch }: FilterRailProps) => {
  const { t } = useTranslation()
  const activeCount = countActiveFilters(filters)

  return (
    <aside aria-label={t('client.directory.filters', 'Filters')} className="hidden lg:block">
      {/* Shortened by the compare tray's height (the CSS variable it publishes)
          so the last groups stay reachable while the tray is up. */}
      <div className="sticky top-[96px] -mr-3 max-h-[calc(100vh_-_112px_-_var(--compare-dock-h,0px))] overflow-y-auto pr-3 [scrollbar-width:thin]">
        <div className="border-navy/10 flex min-h-[48px] items-center justify-between border-b">
          <h2 className="text-navy text-[17px] font-semibold">{t('client.directory.filters', 'Filters')}</h2>
          {activeCount > 0 ? (
            <button
              type="button"
              data-tracking="ignore"
              onClick={() => dispatch({ type: ActionType.ClearFilters })}
              className="text-lapis hover:text-navy cursor-pointer text-[14px] font-medium underline decoration-dotted underline-offset-4"
            >
              {t('client.directory.clearAll', 'Clear all')}
            </button>
          ) : null}
        </div>
        <FilterGroups
          filters={filters}
          filterOptions={filterOptions}
          counts={counts}
          dispatch={dispatch}
          idPrefix="rail"
        />
      </div>
    </aside>
  )
}
